var Connotation = /* @__PURE__ */ ((Connotation2) => {
  Connotation2["Accent"] = "accent";
  Connotation2["CTA"] = "cta";
  Connotation2["Success"] = "success";
  Connotation2["Alert"] = "alert";
  Connotation2["Warning"] = "warning";
  Connotation2["Information"] = "information";
  Connotation2["Announcement"] = "announcement";
  return Connotation2;
})(Connotation || {});
var ConnotationDecorative = /* @__PURE__ */ ((ConnotationDecorative2) => {
  ConnotationDecorative2["Pacific"] = "pacific";
  return ConnotationDecorative2;
})(ConnotationDecorative || {});
var Shape = /* @__PURE__ */ ((Shape2) => {
  Shape2["Rounded"] = "rounded";
  Shape2["Pill"] = "pill";
  Shape2["Circled"] = "circled";
  Shape2["Sharp"] = "sharp";
  return Shape2;
})(Shape || {});
var Appearance = /* @__PURE__ */ ((Appearance2) => {
  Appearance2["Filled"] = "filled";
  Appearance2["Outlined"] = "outlined";
  Appearance2["Duotone"] = "duotone";
  Appearance2["Fieldset"] = "fieldset";
  Appearance2["Subtle"] = "subtle";
  Appearance2["SubtleLight"] = "subtle-light";
  Appearance2["Ghost"] = "ghost";
  Appearance2["GhostLight"] = "ghost-light";
  Appearance2["OutlinedLight"] = "outlined-light";
  Appearance2["Listitem"] = "listitem";
  Appearance2["Elevated"] = "elevated";
  return Appearance2;
})(Appearance || {});
var IconDecoration = /* @__PURE__ */ ((IconDecoration2) => {
  IconDecoration2["Filled"] = "filled";
  IconDecoration2["Outlined"] = "outlined";
  return IconDecoration2;
})(IconDecoration || {});
var Size = /* @__PURE__ */ ((Size2) => {
  Size2["UltraCondensed"] = "ultra-condensed";
  Size2["SuperCondensed"] = "super-condensed";
  Size2["ExtraCondensed"] = "extra-condensed";
  Size2["SemiCondensed"] = "semi-condensed";
  Size2["Condensed"] = "condensed";
  Size2["Normal"] = "normal";
  Size2["SemiExpanded"] = "semi-expanded";
  Size2["Expanded"] = "expanded";
  Size2["ExtraExpanded"] = "extra-expanded";
  Size2["SuperExpanded"] = "super-expanded";
  Size2["UltraExpanded"] = "ultra-expanded";
  return Size2;
})(Size || {});
var LayoutSize = /* @__PURE__ */ ((LayoutSize2) => {
  LayoutSize2["Small"] = "small";
  LayoutSize2["Medium"] = "medium";
  LayoutSize2["Large"] = "large";
  return LayoutSize2;
})(LayoutSize || {});
var Position = /* @__PURE__ */ ((Position2) => {
  Position2["Top"] = "TOP";
  Position2["Bottom"] = "BOTTOM";
  Position2["Start"] = "START";
  Position2["Center"] = "CENTER";
  Position2["End"] = "END";
  return Position2;
})(Position || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["Status"] = "status";
  Role2["Alert"] = "alert";
  return Role2;
})(Role || {});
var AriaLive = /* @__PURE__ */ ((AriaLive2) => {
  AriaLive2["Polite"] = "polite";
  AriaLive2["Assertive"] = "assertive";
  return AriaLive2;
})(AriaLive || {});
var MediaSkipBy = /* @__PURE__ */ ((MediaSkipBy2) => {
  MediaSkipBy2["Zero"] = "0";
  MediaSkipBy2["Five"] = "5";
  MediaSkipBy2["Ten"] = "10";
  MediaSkipBy2["Thirty"] = "30";
  return MediaSkipBy2;
})(MediaSkipBy || {});
var Sticky = /* @__PURE__ */ ((Sticky2) => {
  Sticky2["None"] = "none";
  Sticky2["Header"] = "header";
  Sticky2["Column"] = "column";
  Sticky2["All"] = "all";
  return Sticky2;
})(Sticky || {});

export { Appearance as A, Connotation as C, IconDecoration as I, LayoutSize as L, MediaSkipBy as M, Position as P, Role as R, Shape as S, ConnotationDecorative as a, Size as b, AriaLive as c, Sticky as d };
